'use strict';

function LoanApplicationLoanCustomization() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._hasSeenDialog = false;
  this._paymentOptionObj = null;
  this._fieldsInteractedWith = [];

  this._$classes = {
    form: '.js--loan-application-customization-form',
    checkBox: '.js--loan-application-loan-consent',
    acceptBtn: '.js--loan-protection--accept',
    nextBtn: '.js--next',
    prevBtn: '.js--previous'
  };

  this._paymentOptionReady = $.Deferred();

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    // Guard to prevent users from accessing this page too early without required information
    // This page looks for submitted information
    if (this._loanApplications[0].hasSubmittedIncome() === false) {
      return;
    }

    this._$node = $(this.node);
    this._submissionFlag = false;

    // Check for active loan
    this._isActiveLoan = !!(this._getLoanStatus() && this._getLoanStatus().status && this._getLoanStatus().status === 'active');

    // Form inputs
    this._$loanProtectionConsentInput = this._$node.find(this._$classes.checkBox);

    // Elements
    this._$loanAmountSelector = this._$node.find('.js--loan-amount-selector');
    this.$learnMoreDialogUrl = this._$node.find('.js--loan-protection-dialog__learn_more_url');
    this.$learnMoreDialogContent = $('.js--loan-protection-dialog__learn_more'); // Exists outside of node
    this.$learnMoreDialogCtas = $('.js--loan-protection-dialog__ctas');
    this.$learnMoreDialogDeclineBtn = $('.js--loan-protection--decline');
    this.$learnMoreDialogAcceptBtn = $(this._$classes.acceptBtn);

    this._$form = this._$node.find(this._$classes.form);
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._$prevBtn = this._$node.find(this._$classes.prevBtn);

    // Variables
    this._firstPaymentDate = this._loanApplications[0].getFirstPaymentDate();
    this._payFrequency = this._loanApplications[0].getPayFrequency();
    this._loanApplicationAmount = this._loanApplications[0].getLoanApplicationAmount();
    this._loanApplicationTerms = this._loanApplications[0].getTermsInPreferredUnits();
    this._loanApplicationModel = this._loanApplications[0].getModelPath();
    this._loanApplicationProtected = this._loanApplications[0].isProtected();
    this._originalLoanApplicationProtected = this._loanApplications[0].isProtected();
    this._isLastPayOfMonth = this._loanApplications[0].isLastPayOfMonth();
    this._loanProtectionPolicy = null; // declare variable onGetPaymentOptionCallback
    this._loanApplicationLenderId = this._loanApplications[0].getApplicationLender();

    // Ref paths ie 'money.applications.loan_applications[0].terms
    this._termsReference = this._loanApplications[0].getTermsReference();
    this._aprReference = this._loanApplications[0].getAprReference();
    this._protectionReference = this._loanApplications[0].getProtectionReference();

    // Get payment options from offersObj
    this._loanOfferAmount = this._activeOffer.getOfferAmount();

    // Set ups
    this._pushPageAnalytics();
    this._setTempPayOptionModel();
    this._setupEventHandlers();

    // wait for payment options to be ready, key to data-bind values
    $.when(this._paymentOptionReady).done(this._setupLoanCustomization.bind(this));
  };

  this._createDynamicCheckbox = function (lenderId) {
    var content = '';

    switch (lenderId) {
      case 1:
        content = 'I want to participate in the optional loan balance protection plan.';
        break;
      case 2:
        content = 'Please provide me with further information on how to protect my loan with the optional Loan Protection Plan and the insurance application.';
        break;
      default:
        content = 'I want to participate in the optional loan balance protection plan.';
    }

    _this._$loanProtectionConsentInput.mogo().create('Checkbox', {
      placeholder: content
    });

    _this._setDefaultCheckboxBehaviour(lenderId);
  };

  this._setTempPayOptionModel = function () {
    // use Submitted Loan Amount to populate screen
    if (!this._loanApplicationAmount) {
      // use Offer amount
      this._activeOffer.getPaymentOption(this._loanOfferAmount, this._onGetPaymentOptionCallback.bind(this));
    } else {
      // else use the Offer Amount from Approved Product
      // use submitted loan amount value to retrieve pay option
      this._activeOffer.getPaymentOption(this._loanApplicationAmount, this._onGetPaymentOptionCallback.bind(this));
    }
  };

  this._onGetPaymentOptionCallback = function (payOption) {
    // No Model create one , else update the model else create model,
    if (!this.presenter.getModelProperty('money._loanApplicationPayOption')) {
      payOption.valid = true;
      this.presenter.createModel('money._loanApplicationPayOption', {
        data: payOption
      });
    } else {
      payOption.valid = true;
      this.presenter.updateModel('money._loanApplicationPayOption', payOption);
    }

    // Returns whether the user is eligible for LP.
    // Determines by checking loan_policy_number &&
    // if loan_protection_amount key exists
    if (this._loanApplications[0].isProtectionEligible() || payOption.protection_policy_number && $.isEmptyObject(payOption.loan_protection_amount) !== true // no key in the object
    ) {
        // setup dynamic content
        this._createDynamicCheckbox(this._loanApplicationLenderId); // Content depends on lender
        this._setupDialogBtnLabel(this._loanApplicationLenderId);
        // payOption is a dependency for a few things
        this.isLoanProtectionEligible = true;
        this._loanProtectionPolicy = payOption.protection_policy_number;
        this._attachLearnMoreButtonAttribute(this._loanProtectionPolicy); // attach data ID
        this._pushLoanCustomOptionAnalytics(this._loanProtectionPolicy, this._loanOfferAmount);
      } else {
      this.isLoanProtectionEligible = false;
      this._pushLoanCustomOptionAnalytics(false, this._loanOfferAmount);
    }

    this._paymentOptionReady.resolve();
  };

  this._setupDialogBtnLabel = function (lenderId) {
    if (lenderId !== 1) {
      $(_this._$classes.acceptBtn)[0].innerText = 'Yes, I’m interested';
    }
  };

  this._setDefaultCheckboxBehaviour = function (lenderId) {
    // Set Loan Protection to True if:
    // - first time a Mogo Loan Applicant sees this page
    // - loanApplicationProtected is True from prior selection
    if (_this._loanApplicationProtected == undefined || _this._loanApplicationProtected == null) {
      if (lenderId === 1) {
        _this._$loanProtectionConsentInput.mogo().setChecked(true);
        _this.presenter.setModelProperty(_this._protectionReference, true);
      } else {
        _this.presenter.setModelProperty(_this._protectionReference, false);
      }
    } else {
      mogo.ready(function () {
        _this._$loanProtectionConsentInput.mogo().setChecked(_this._loanApplicationProtected);
        // for analytics
        _this._onFieldInteraction($(_this._$classes.checkBox));
      });
    }
  };

  this._setupLoanCustomization = function () {
    var paymentDates = [];
    // Construct Next payment data, TODO: refine data and loop
    if (this._payFrequency === 'monthly' || this._payFrequency === 'semi_monthly') {
      if (this._isLastPayOfMonth) {
        paymentDates = [moment(), moment(this._firstPaymentDate), moment(this._firstPaymentDate).add(1, 'months').endOf('Month'), moment(this._firstPaymentDate).add(2, 'months').endOf('Month')];
      } else {
        var submittedDate = this._loanApplications[0].getSubmittedPaymentDate();
        paymentDates = this._createMoment(submittedDate, this._firstPaymentDate);
      }
    } else if (this._payFrequency === 'bi_weekly' || this._payFrequency === 'weekly') {
      paymentDates = [moment(), moment(this._firstPaymentDate), moment(this._firstPaymentDate).add(2, 'weeks'), moment(this._firstPaymentDate).add(4, 'weeks')];
    }

    // Title content is different when offer amount is 2000
    this._setupComputedVariables();
    this._renderPaymentPlanDates(paymentDates);

    // Create LoanAmountSelector when data is ready.
    var amountsArr = Object.keys(this._activeOffer._paymentOptions);
    this._$loanAmountSelector.mogo().create('LoanAmountSelector', {
      presenter: this.presenter,
      amountPropertyModel: 'money._loanApplicationPayOption.amount',
      defaultAmount: this._loanOfferAmount,
      maxValue: this._activeOffer._paymentOptions[amountsArr[amountsArr.length - 1]].amount,
      minValue: this._activeOffer._paymentOptions[amountsArr[0]].amount,
      onClick: this._updatePaymentPlan.bind(this)
    });

    // Remove Page Progress loader
    this._removeProgressLoader();
  };

  this._renderPaymentPlanDates = function (arr) {
    var $paymentPlanScale = $('.js--payment-plan-scale');

    // Data bind loan payment amount so it automatically updates.
    // Open to using JAVASCRIPT
    var template = function template(date) {
      if (date) {
        return '<div class="payment-plan__scale-item">\n        <span class="date payment-play__scale-item-date">' + date + '</span>\n            <span class="amount payment-play__scale-item-amount"><span data-bind="loan_amount_due"></span>due</span>\n          </div>';
      }
      return '<div class="payment-plan__scale-item">\n        <span data-bind="payment_plan_loan_amount_term" class="date payment-play__scale-item-date"></span>\n            <span class="amount payment-play__scale-item-amount"><span data-bind="loan_amount_due"></span>due</span>\n          </div>';
    };

    var paymentPlanScaleItems = arr.map(function (element) {
      // Format IE Mon, Jan, 21
      var date = element.format('ddd, MMM D');
      return template(date);
    }).join('');

    // construct last item last Item of plan scale
    var $paymentPlantScaleMax = template();

    // add items to paymentScalePlan element , Add last `up to x years` item
    $paymentPlanScale.append(paymentPlanScaleItems + $paymentPlantScaleMax);

    // pay scale is dynamically generated
    this.presenter.scanDOM($paymentPlanScale);
  };

  // Onclick function attached to the loan amount selector buttons
  this._updatePaymentPlan = function (loanAmount) {
    var _this2 = this;

    // for Form abandonment data
    $('.js--loan-amount-selector').find('input')[0].dataset.interacted = true;

    this._activeOffer.getPaymentOption(loanAmount, function (payOption) {
      // Update Temp model so data binds value in UI will be updated
      if (_this2.presenter.models.money._loanApplicationPayOption) {
        if (payOption) {
          payOption.valid = true;
          _this2.presenter.updateModel('money._loanApplicationPayOption', payOption);
        } else {
          payOption = {
            valid: false,
            amount: loanAmount
          };
          _this2.presenter.updateModel('money._loanApplicationPayOption', payOption);
        }
      }
    });
  };

  this._createMoment = function (date, firstPaymentDate) {
    if (!date) return console.warn('invalid date');
    // Fix UI bug where user selects 28 or 29 and a projected estimated date is on Feb 28th.
    // Need to illustrate to users that their payment will fall one day after that on March 1st.
    var year = moment().format('YYYY');
    var month = parseInt(moment(firstPaymentDate).format('MM')) - parseInt(moment(date).format('MM'));

    var dayOfMonth = moment(date).format('DD');
    var dayDifference = parseInt(moment(firstPaymentDate).format('DD')) - parseInt(moment(date).format('DD')); // Fix UI bug where user selects 28 or 29 and a projected estimated date is on Feb 28th.
    var dayIncrement = Math.abs(dayDifference) > 0 ? 1 : 0; // Need to illustrate to users that their payment will fall one day after that on March 1st.

    // % 12 to get current year value
    var dateString = [moment(), moment(firstPaymentDate).add(dayIncrement, 'days'), moment([year, 0, dayOfMonth]).add((month + 1) % 12, 'months'), moment([year, 0, dayOfMonth]).add((month + 2) % 12, 'months')];

    return dateString.filter(function (element, index, arr) {
      // Projected date - First Payment Date
      var dateDifference = parseInt(element.format('DD')) - parseInt(moment(firstPaymentDate).format('DD'));
      if (index > 0 && // Not the first date
      Math.abs(dateDifference) > 0 && // if date discrepancy
      element.format('MM-DD') === '02-28' // If its on this special day
      ) {
          return arr[index].add(1, 'days');
        }
      return arr[index];
    });
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setupEventHandlers = function () {
    var _this3 = this;

    this._$prevBtn.on('click', function () {
      $('#LoanApplicationTray').mogo()._loanAppGoToPreviousStep();
    });

    // On Decline, is_protect = false, continue to submit
    this.$learnMoreDialogDeclineBtn.on('click', function (e) {
      e.preventDefault();
      _this3.$learnMoreDialogDeclineBtn.mogo().setDisabledLoadState();
      _this3.$learnMoreDialogAcceptBtn.mogo().setDisabledState();
      var data = _this3._$form.serializeFormToObj();
      // Input data
      var payload = {
        amount: parseInt(data.loan_amount),
        is_protected: false
      };

      _this3._loanApplications[0].updateLoanApplication(payload, {
        success: _this3._onUpdateLoanApplicationSuccess.bind(_this3),
        failure: function () {
          this.$learnMoreDialogDeclineBtn.mogo().removeDisabledLoadState();
          this._onUpdateLoanApplicationFailure.bind(this);
        }.bind(_this3)
      });
    });

    this.$learnMoreDialogAcceptBtn.on('click', function (e) {
      e.preventDefault();
      _this3.$learnMoreDialogAcceptBtn.mogo().setDisabledLoadState();
      _this3.$learnMoreDialogDeclineBtn.mogo().setDisabledState();
      _this3._$loanProtectionConsentInput.mogo().setChecked(true);
      var data = _this3._$form.serializeFormToObj();
      // Input data
      var payload = {
        amount: parseInt(data.loan_amount),
        is_protected: true // User want protection, go to next step
      };

      _this3._loanApplications[0].updateLoanApplication(payload, {
        success: _this3._onUpdateLoanApplicationSuccess.bind(_this3),
        failure: function () {
          this.$learnMoreDialogAcceptBtn.mogo().removeDisabledLoadState();
          this._onUpdateLoanApplicationFailure.bind(this);
        }.bind(_this3)
      });
    });

    // Events
    this.$learnMoreDialogUrl.on('click', function (e) {
      _this3.$learnMoreDialogContent.mogo().show();

      var modalId = _this3._loanProtectionPolicy + ' Learn More';
      _this3._pushModelDialog(modalId, 'Shown');

      if (!_this3.$learnMoreDialogCtas.hasClass('hide')) _this3.$learnMoreDialogCtas.addClass('hide');

      // IE11 fix, IE11 does not support srcset
      if (typeof picturefill === 'function') picturefill();
    });

    this._$loanProtectionConsentInput.on('click', function (e) {
      // Need this event handler to dynamically generate payment amount with protection premium
      if ($(e.target).mogo().val() === 'on') {
        _this3.presenter.setModelProperty(_this3._protectionReference, true);
      } else {
        _this3.presenter.setModelProperty(_this3._protectionReference, false);
      }
    });

    // Abandon form data
    this._onFieldInteraction($('.js--loan-application-loan-consent'));

    this._$form.on('submit', this._onValidateForm.bind(this));
    this.presenter.scanDOM($('#learnMoreDialog'));
  };

  this._onValidateForm = function (e) {
    if (e) e.preventDefault();
    $.each(this._$nextBtn, function (index, value) {
      value.mogo().setDisabledLoadState();
    });
    var data = this._$form.serializeFormToObj();

    if (parseInt(data.loan_amount) > this._loanOfferAmount) {
      $.each(this._$nextBtn, function (index, value) {
        value.mogo().removeDisabledLoadState();
      });
      // Success Loan Amount Customization Analytics
      this.analytics.forcePushEvent('loan-amount-customization', {
        LoanAmountCustomization: ['Loan Limit Exceeded']
      });
      this._pushFormErrorAnalytics('loan_amount');
      return;
    }

    // Input data
    var payload = {
      amount: parseInt(data.loan_amount),
      is_protected: data.is_protected
    };

    // LP reminder logic
    if (this._hasSeenDialog || payload.is_protected === true || this.isLoanProtectionEligible === false || this._originalLoanApplicationProtected === false && payload.is_protected === false) {
      this._loanApplications[0].updateLoanApplication(payload, {
        success: this._onUpdateLoanApplicationSuccess.bind(this),
        failure: this._onUpdateLoanApplicationFailure.bind(this)
      });
    } else {
      if (e) e.preventDefault();
      // Remove spinner when dialog is shown
      $.each(this._$nextBtn, function (index, value) {
        value.mogo().removeDisabledLoadState();
      });
      this.$learnMoreDialogContent.mogo().show();
      this.$learnMoreDialogCtas.removeClass('hide');

      var modalId = this._loanProtectionPolicy + ' Forced Choice';
      this._pushModelDialog(modalId, 'Shown');

      this._hasSeenDialog = true;
    }
  };

  this._onUpdateLoanApplicationSuccess = function (data, response) {
    // Success Loan Amount Customization Analytics
    var loanAmount = data.amount;
    var amountAdvanced = null;
    if (this.presenter.getModelProperty(this._liquidLoanPath + '.effective_balance')) {
      amountAdvanced = this.presenter.getModelProperty('money._loanApplicationPayOption.amount') - this.presenter.getModelProperty(this._liquidLoanPath + '.effective_balance');
    }

    this.analytics.forcePushEvent('loan-amount-customization', {
      LoanAmountCustomization: [loanAmount],
      LoanAmountAdvanced: [amountAdvanced]
    });
    this._submitAnalyticsForm(); // Submit Analytics
    this._setSubmissionFlag(true);
    $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();
  };

  this._onUpdateLoanApplicationFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });
      $.each(this._$nextBtn, function (index, value) {
        value.mogo().removeDisabledLoadState();
      });
      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };

  this._attachLearnMoreButtonAttribute = function (policy) {
    var dataAnalyticsId = '';

    if (policy) dataAnalyticsId = 'Money-' + policy + ' Forced Choice';

    // Attach Data Attributes
    this.$learnMoreDialogAcceptBtn.attr('data-analytics-id', dataAnalyticsId + '-Yes-Null-Component');
    this.$learnMoreDialogDeclineBtn.attr('data-analytics-id', dataAnalyticsId + '-No-Null-Component');

    // Scan node for Analytics
    $('#Portal').mogo().scanNodeForClickAnalytics(this.$learnMoreDialogContent);
  };

  this._setupComputedVariables = function () {
    var _this4 = this;

    // Format Money on the pug view will make the cents portion smaller
    this._paymentFrequency = this._loanApplications[0].getPaymentFrequency();

    this.presenter.addComputedVariable('offer_amount', [this._loanApplicationModel + '.amount'], function (val) {
      return _this4._activeOffer.getOfferAmount();
    } // Offer Amount
    );

    this.presenter.addComputedVariable('loan_payment_amount', ['money._loanApplicationPayOption', this._protectionReference], function (val) {
      if (val.valid) {
        var isProtected = _this4._loanApplications[0].isProtected();
        var paymentFrequency = 0;
        var paymentAmount = 0;
        var premium = 0;

        if (isProtected) {
          // Amount with premium
          paymentFrequency = _this4.presenter.getModelProperty('money._loanApplicationPayOption.' + _this4._paymentFrequency);
          premium = _this4.presenter.getModelProperty('money._loanApplicationPayOption.loan_protection_amount.' + _this4._paymentFrequency);
          paymentAmount = paymentFrequency + premium;
        } else {
          paymentFrequency = _this4.presenter.getModelProperty('money._loanApplicationPayOption.' + _this4._paymentFrequency);
          paymentAmount = paymentFrequency;
        }
        return paymentAmount.toFixed(2).toString();
      }
      return '';
    });

    // This is for the paymentScale
    this.presenter.addComputedVariable('loan_amount_due', ['money._loanApplicationPayOption', this._protectionReference], function (val) {
      if (val.valid) {
        var isProtected = _this4._loanApplications[0].isProtected();
        var paymentFrequency = 0;
        var paymentAmount = 0;
        var premium = 0;

        if (isProtected) {
          // Amount with premium
          paymentFrequency = _this4.presenter.getModelProperty('money._loanApplicationPayOption.' + _this4._paymentFrequency);
          premium = _this4.presenter.getModelProperty('money._loanApplicationPayOption.loan_protection_amount.' + _this4._paymentFrequency);
          paymentAmount = paymentFrequency + premium;
        } else {
          paymentFrequency = _this4.presenter.getModelProperty('money._loanApplicationPayOption.' + _this4._paymentFrequency);
          paymentAmount = paymentFrequency;
        }
        return '$' + paymentAmount.toFixed(2).toString() + ' ';
      }
      return ' - ';
    });

    // Use protection reference property because this property gets set on click
    // Dynamically display LP disclaimer on LP option
    this.presenter.addComputedVariable('loan_premium_disclaimer', ['money._loanApplicationPayOption', this._protectionReference], function (val) {
      if (val.valid) {
        var isProtected = _this4._loanApplications[0].isProtected();
        // LP option checkbox selection
        if (isProtected) {
          var premiumAmount = _this4.presenter.getModelProperty('money._loanApplicationPayOption.loan_protection_amount.' + _this4._paymentFrequency);
          // premium value is different color
          return Formatters.formatMoney(premiumAmount);
        }
      }
      return '-';
    });

    this.presenter.addComputedVariable('loan_amount_term', ['money._loanApplicationPayOption', this._termsReference], function (selectedOption, fallbackTerms) {
      if (selectedOption.display_terms_as) {
        if (selectedOption.display_terms_as === 'month') {
          return selectedOption.term_months + ' month ';
        }
        return selectedOption.term_months / 12 + ' year ';
      }
      var year = '';
      if (fallbackTerms) {
        return Math.floor(fallbackTerms / 12) + ' year ';
      }
    });

    this.presenter.addComputedVariable('payment_plan_loan_amount_term', ['money._loanApplicationPayOption', this._termsReference], function (selectedOption, fallbackTerms) {
      var result = '';
      if (selectedOption.display_terms_as) {
        if (selectedOption.display_terms_as === 'month') {
          result = selectedOption.term_months + ' month';
        } else if (selectedOption.term_months / 12 === 0) {
          result = '-';
        } else {
          result = selectedOption.term_months / 12 + ' year';
        }
      } else {
        var year = '';
        if (fallbackTerms) {
          if (Math.floor(fallbackTerms / 12) === 0) {
            result = '-';
          } else {
            result = Math.floor(fallbackTerms / 12) + ' year';
          }
        }
      }
      if (result === '-') return result;
      return result.indexOf('1 ') >= 0 ? 'Up to ' + result : 'Up to ' + result + 's';
    });

    this.presenter.addComputedVariable('loan_amount_apr', [this._aprReference], function (apr) {
      if (apr) {
        return ' ' + apr;
      }
      return '';
    });

    this.presenter.addComputedVariable('is_protected', [this._protectionReference], function (val) {
      return val;
    });

    this.presenter.addComputedVariable('lp_eligible', ['money._loanApplicationPayOption.amount'], function (val) {
      return _this4.isLoanProtectionEligible;
    } // Calculated on pay option ready
    );

    // loan recurrence depends on employment pay frequency,
    // IF semi monthly or monthly, display monthly
    // if weekly or bi weekly, display bi-weekly
    this.presenter.addComputedVariable('loan_recurrence', [this._loanApplicationModel + '.employment.pay_frequency'], function (recurrence) {
      switch (recurrence) {
        case 'semi_monthly':
        case 'monthly':
          return 'Monthly';
        case 'bi_weekly':
        case 'weekly':
          return 'Bi-weekly';
      }
    });

    // Display effective balance if there's an active loan
    // because user will be applying for a level up offer.
    if (this._isActiveLoan) {
      // Effective Balance: principal.amount_remaining - (next_payment.amount + next_payment.lp)
      this.presenter.addComputedVariable(
      // _liquidLoanPath is from MoneyController
      'loanEffectiveBalance', ['money._loanApplicationPayOption.amount', this._liquidLoanPath + '.effective_balance'], function (selectedAmount, effectiveBalance) {
        if (selectedAmount && effectiveBalance) {
          var calculatedAmount = selectedAmount - effectiveBalance;
          if (selectedAmount < _this4._activeOffer._paymentOptions[Object.keys(_this4._activeOffer._paymentOptions)[0]].amount || selectedAmount > _this4._activeOffer.getOfferAmount()) {
            return '-';
          }
          return Formatters.formatMoney(selectedAmount - effectiveBalance);
        }
      });

      this.presenter.addComputedVariable('loanAmountRemaining', [this._liquidLoanPath + '.effective_balance'], function (val) {
        return Formatters.formatMoney(val.toFixed(2));
      });

      // Setup tooltip binds
      mogo.ready(function () {
        if ($('#customization-tooltip').length) {
          var $tooltipNode = $('#customization-tooltip').mogo()._$nodeCopy;
          $tooltipNode.find('.loan-amount-remaining')[0].setAttribute('data-bind', 'loanAmountRemaining');
          $tooltipNode.find('.loan-effective-balance')[0].setAttribute('data-bind', 'loanEffectiveBalance');
          _this4.presenter.scanDOM($tooltipNode[0]);
        }
      });
    }
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('loan_payment_amount');
    this.presenter.removeComputedVariable('loan_recurrence');
    this.presenter.removeComputedVariable('loan_amount_apr');
    this.presenter.removeComputedVariable('loan_amount_due');
    this.presenter.removeComputedVariable('loan_premium_disclaimer');
    this.presenter.removeComputedVariable('is_protected');
    this.presenter.removeComputedVariable('loan_amount_term');
    this.presenter.removeComputedVariable('lp_eligible');

    if (this.$learnMoreDialogContent && this.$learnMoreDialogContent.length) this.$learnMoreDialogContent.mogo().destroy();

    if (this._submissionFlag === false) {
      this._pushAbandonmentData();
    }

    if (this._isActiveLoan) {
      this.presenter.removeComputedVariable('loanEffectiveBalance');
      this.presenter.removeComputedVariable('loanAmountRemaining');
    }

    this._super();
  };

  // Analytics
  this._setSubmissionFlag = function (boolean) {
    if (boolean !== null) this._submissionFlag = boolean;
  };

  this._findInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        this._fieldsInteractedWith.push(fields[i].name);
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        this._fieldsInteractedWith.push($(fields[i].parentElement).attr('name'));
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }
  };

  this._pushPageAnalytics = function () {
    var url = window.location.pathname + (this.presenter.getModelProperty('money._loanApplicationEdit') === true ? '-edit' : '');

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._pushAbandonmentData = function () {
    this._findInteractedFields();

    if (this._fieldsInteractedWith.length) {
      this.analytics.forcePushEvent('form-abandoned', {
        FormAbandoned: [this._fieldsInteractedWith.join(', ')]
      });
    }
  };

  // TODO: need clarification from analytics
  this._pushModelDialog = function (id, action) {
    var modalId = id || 'Unavailable';
    var modalAction = action || 'Unavailable';

    this.analytics.forcePushEvent('modal-dialog', {
      modalDialogID: [modalId],
      modalDialogAction: [modalAction]
    });
  };

  this._pushLoanCustomOptionAnalytics = function (lpOption, maxAmount) {
    var lp = lpOption ? 'LP Eligible ' + lpOption : 'LP Not Eligible';
    var amount = maxAmount || '';

    this.analytics.pushEvent('loan-custom-options', {
      LoanCustomOptionsLP: [lp],
      LoanCustomOptionsMaxAmount: [amount]
    });
  };

  this._onFieldInteraction = function (domElement) {
    var elemName = domElement.attr('name');

    if (!elemName) return console.warn('Cannot find name in domElement, please pass through correct domElement');

    var elem = $('[name=\'' + elemName + '\']', this.node);
    var fieldComponent = $(elem).mogo();

    // From UI Schema Validation
    if (fieldComponent instanceof Select) {
      $(fieldComponent.containerDiv).on('enter', setInteractionField.bind(this, elem));
      $(fieldComponent.containerDiv).on('leave', setInteractionField.bind(this, elem));
      $(elem).on('focus', setInteractionField.bind(this, elem));
      $(elem).on('blur', setInteractionField.bind(this, elem));
    } else if (fieldComponent instanceof BooleanGroup) {
      for (var j = 0; j < fieldComponent.groupElements.length; j++) {
        $(fieldComponent.groupElements[j]).on('focus', setInteractionField.bind(this, elem));
        $(fieldComponent.groupElements[j]).on('blur', setInteractionField.bind(this, elem));
      }
    } else {
      $(fieldComponent.containerDiv).on('enter', setInteractionField.bind(this, elem));
      $(fieldComponent.containerDiv).on('leave', setInteractionField.bind(this, elem));
      $(elem).on('change', setInteractionField.bind(this, elem));
      $(elem).on('focus', setInteractionField.bind(this, elem));
      $(elem).on('blur', setInteractionField.bind(this, elem));
      $(elem).on('click', setInteractionField.bind(this, elem));
    }

    function setInteractionField(elem, event) {
      $(elem)[0].dataset.interacted = true;
    }
  };

  this._pushFormErrorAnalytics = function (formId) {
    var formErrorId = null;
    if (formId) formErrorId = formId;

    this.analytics.forcePushEvent('form-errors', {
      FormErrors: [formErrorId]
    });
  };

  this._submitAnalyticsForm = function () {
    if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['Money-Form Submission-Loan Customization Options Edit-null-Form']
      });
    } else {
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['Money-Form Submission-Loan Customization Options-null-Form']
      });
    }
  };
}